import React from 'react';
import { ImSpinner2 } from 'react-icons/im';

export const LoadingComponent = () => (
  <div className="flex items-center justify-center w-full h-full">
    <ImSpinner2 className="w-6 h-6 text-gray-600 animate-spin" />
  </div>
);
